import { modifyCurrency } from 'utilities/transformer'
import actions from './actions'

import newActions from '../newTrade/actions'
import tradeActions from '../trade/actions'

const initialState = {
  isCountriesFetched: false,
  previoiusLocation: '',
  countries: [],

  introducers: [],
  merchants: [],
  introducerClients: [],
  merchantClients: [],
  clients: [],
  clientPartners: [],
  client: {},
  currencies: [],
  newCurrencies: [],
  sourceCurrencies: [],
  targetCurrencies: [],
  beneficiaries: [],
  bankAccounts: [],
  clientBeneficiaries: [],
  currentTradeClient: {},
  vendors: [],
  pagination: {
    pageSize: 10,
    current: 1,
    total: 0,
  },
  isCustomerLoading: false,
  // streamingChannels: {},
  defaultLandingPage: '',
}

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.value,
        isCountriesFetched: !state.isCountriesFetched,
      }
    case actions.UPDATE_PREVIOUS_LOCATION:
      return {
        ...state,
        previoiusLocation: action.url,
      }
    case actions.GET_INTRODUCERS_SUCCESS:
      return {
        ...state,
        introducers: action.value.client,
      }
    case actions.GET_MERCHANTS_SUCCESS:
      return {
        ...state,
        merchants: action.value.client,
      }
    case actions.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.value.client,
      }
    case actions.GET_INTRODUCERS_CLIENTS_SUCCESS:
      return {
        ...state,
        introducerClients: action.value.client,
      }
    case actions.GET_MERCHANTS_CLIENTS_SUCCESS:
      return {
        ...state,
        merchantClients: action.value.client,
      }
    case actions.GET_RC_CURRENCIES:
      return {
        ...state,
      }
    case actions.GET_RC_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: modifyCurrency(action.value.currency),
      }
    case actions.GET_RC_CURRENCIES_FAILURE:
      return {
        ...state,
      }
    case actions.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: modifyCurrency(action.value),
      }
    case actions.GET_CURRENCIES_BY_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        sourceCurrencies: action.value.sourceCurrency,
        targetCurrencies: action.value.destinationCurrency,
      }
    case newActions.GET_BENEFICIARY_BY_CLIENT_ID_SUCCESS:
      return {
        ...state,
        clientBeneficiaries: action.value,
      }

    case tradeActions.GET_TRADE_DETAILS_BY_ID_SUCCESS: {
      const filteredBene = state.beneficiaries.filter(el => el.client === action.value.clientId)
      const filteredClient = state.clients.find(el => el.id === action.value.clientId)
      return {
        ...state,
        clientBeneficiaries: filteredBene,
        currentTradeClient: filteredClient,
      }
    }
    case actions.GET_CLIENT_BY_ID:
      return {
        ...state,
        isCustomerLoading: true,
      }
    case actions.GET_CLIENT_BY_ID_DEPRECATED:
      return {
        ...state,
        isCustomerLoading: true,
      }
    case actions.GET_CLIENT_BY_ID_SUCCESS: {
      const defaultLandingPage = '/activate-account'
      // const { profile } = action.value
      // const { productPreferences } = profile
      // productPreferences.forEach(product => {
      //   if (product === 'restricted_currencies' || product === 'remittance') {
      //     defaultLandingPage = '/trades'
      //   }
      //   if (product === 'currency_accounts') {
      //     defaultLandingPage = '/account-balances'
      //   }
      // })
      return {
        ...state,
        client: action.value,
        defaultLandingPage,
        isCustomerLoading: false,
      }
    }

    case actions.GET_CLIENT_BY_ID_FAILURE:
      return {
        ...state,
        isCustomerLoading: false,
      }
    case actions.GET_CLIENT_PARTNER_BY_PARENT_ID:
      return {
        ...state,
      }
    case actions.GET_CLIENT_PARTNER_BY_PARENT_ID_SUCCESS:
      return {
        ...state,
        clientPartners: action.value,
      }
    case actions.GET_CLIENT_PARTNER_BY_PARENT_ID_FAILURE:
      return {
        ...state,
      }
    default:
      return state
  }
}
